import { render, staticRenderFns } from "./ServiceObjectsOverview.vue?vue&type=template&id=221f011a&scoped=true"
import script from "./ServiceObjectsOverview.vue?vue&type=script&lang=js"
export * from "./ServiceObjectsOverview.vue?vue&type=script&lang=js"
import style0 from "./ServiceObjectsOverview.vue?vue&type=style&index=0&id=221f011a&prod&lang=css"
import style1 from "./ServiceObjectsOverview.vue?vue&type=style&index=1&id=221f011a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221f011a",
  null
  
)

export default component.exports